import T from '../../common/components/T';
import { mediaSkeleton } from '../plug/Skeleton/components/patterns';

export const skeleton = (breakpoint) => {
    return [
        {
            type: 'circle',
            align: 'right',
            diameter: 3
        },
        {
            type: 'title',
            align: 'center',
            width: 50
        },
        'empty',
        {
            row: mediaSkeleton(breakpoint, { 767: [50, 50] }, [100]),
            items: mediaSkeleton(
                breakpoint,
                {
                    767: [
                        {
                            row: [30, 70],
                            items: [
                                {
                                    type: 'circle',
                                    diameter: 10
                                },
                                {
                                    content: [
                                        {
                                            type: 'text'
                                        },
                                        {
                                            type: 'subtitle'
                                        },
                                        {
                                            type: 'table',
                                            size: {
                                                columns: 2,
                                                rows: 1
                                            }
                                        },
                                        {
                                            row: [10, 10, 10],
                                            items: ['circle', 'circle', 'circle'],
                                            align: 'left'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            row: [30, 70],
                            items: [
                                {
                                    type: 'circle',
                                    diameter: 10
                                },
                                {
                                    content: [
                                        {
                                            type: 'text'
                                        },
                                        {
                                            type: 'subtitle'
                                        },
                                        {
                                            type: 'table',
                                            size: {
                                                columns: 2,
                                                rows: 1
                                            }
                                        },
                                        {
                                            row: [10, 10, 10],
                                            items: ['circle', 'circle', 'circle'],
                                            align: 'left'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                [
                    {
                        content: [
                            {
                                row: [30, 70],
                                items: [
                                    {
                                        type: 'circle',
                                        diameter: mediaSkeleton(breakpoint, { 767: 10 }, 6)
                                    },
                                    {
                                        content: [
                                            {
                                                type: 'text'
                                            },
                                            {
                                                type: 'subtitle'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                type: 'table',
                                size: {
                                    columns: 2,
                                    rows: 1
                                }
                            },
                            {
                                row: [10, 10, 10],
                                items: ['circle', 'circle', 'circle'],
                                align: 'left'
                            },
                            'empty',
                            {
                                row: [30, 70],
                                items: [
                                    {
                                        type: 'circle',
                                        diameter: mediaSkeleton(breakpoint, { 767: 10 }, 6)
                                    },
                                    {
                                        content: [
                                            {
                                                type: 'text'
                                            },
                                            {
                                                type: 'subtitle'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                type: 'table',
                                size: {
                                    columns: 2,
                                    rows: 1
                                }
                            },
                            {
                                row: [10, 10, 10],
                                items: ['circle', 'circle', 'circle'],
                                align: 'left'
                            },
                            'empty'
                        ]
                    }
                ]
            ),
            gap: 2
        },
        'line',
        'empty',
        {
            type: 'subtitle',
            width: 50,
            align: 'center'
        },
        'empty',
        {
            row: mediaSkeleton(breakpoint, { 767: [33, 33, 33, 33, 33, 33] }, [100]),
            items: mediaSkeleton(
                breakpoint,
                {
                    767: [
                        {
                            type: 'blockMD'
                        }
                    ]
                },
                [
                    {
                        content: ['blockSM', 'blockSM', 'blockSM', 'blockSM', 'blockSM', 'blockSM']
                    }
                ]
            )
        },
        'empty',
        'line',
        'empty',
        {
            row: mediaSkeleton(breakpoint, { 767: [50, 50] }, [100]),
            gap: 2,
            items: mediaSkeleton(
                breakpoint,
                {
                    767: [
                        {
                            content: [
                                {
                                    type: 'subtitle',
                                    width: 50,
                                    align: 'center'
                                },
                                'empty',
                                {
                                    row: [50, 50, 50, 50],
                                    items: ['blockLG'],
                                    gap: 1
                                }
                            ]
                        },
                        {
                            content: [
                                {
                                    type: 'subtitle',
                                    width: 50,
                                    align: 'center'
                                },
                                'empty',
                                {
                                    row: [50, 50],
                                    gap: 1,
                                    items: [
                                        {
                                            content: [
                                                {
                                                    type: 'circle',
                                                    align: 'center',
                                                    diameter: 6
                                                },
                                                {
                                                    type: 'blockSM'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                [
                    {
                        content: [
                            {
                                type: 'subtitle',
                                width: 50,
                                align: 'center'
                            },
                            'empty',
                            'blockLG',
                            'blockLG',
                            'blockLG',
                            'blockLG',
                            'empty',
                            'line',
                            'empty',
                            {
                                type: 'circle',
                                diameter: 10,
                                align: 'center'
                            },
                            'blockSM',
                            'empty',
                            {
                                type: 'circle',
                                diameter: 10,
                                align: 'center'
                            },
                            'blockSM',
                            'empty'
                        ]
                    }
                ]
            )
        }
    ];
};

export const createStats = (partnerStats) => {
    if (!partnerStats) return null;
    // const binarData = partnerStats?.stats?.partners_in_structures?.find((structure) => +structure?.structure?.width === 2);

    return [
        {
            name: <T textName='new-partners' defaultStr='Новые партнеры' />,
            // value: partnerStats?.stats?.new_partners?.number || '0',
            value: partnerStats?.totalByPeriod.toLocaleString() || '0',
            icon: 'plus-with-elipse'
        },
        {
            name: <T textName='personal-invited' defaultStr='Лично приглашенные' />,
            value: partnerStats?.children?.toLocaleString() || '0',
            icon: 'handshake-with-elipse'
        },
        {
            name: <T textName='active-partners' defaultStr='Активные партнеры' />,
            value: partnerStats?.total?.toLocaleString() || '0',
            icon: 'star-with-elipse'
        },
        {
            name: <T textName='partners-in-binar-active' defaultStr='Активные в бинаре' />,
            value: [partnerStats?.left?.toLocaleString() || '0', partnerStats?.right?.toLocaleString() || '0'],
            icon: 'branches-with-elipse',
            hint: (
                <T
                    textName='active-binar-partners-number'
                    defaultStr='Количество активных партнеров в левой и правой ветках бинара'
                />
            )
        }
        // {
        //     name: <T textName='all-partners' defaultStr='Всего партнеров' />,
        //     value: partnerStats?.stats?.partners?.number || '0',
        //     icon: 'users-fill-colored'
        // }
    ];
};

export const partnerStatsSkeleton = (breakpoint) => {
    return [
        'empty',
        {
            type: 'subtitle',
            width: 50,
            align: 'center'
        },
        'empty',
        {
            row: mediaSkeleton(breakpoint, { 767: [33, 33, 33, 33, 33, 33] }, [100]),
            items: mediaSkeleton(
                breakpoint,
                {
                    767: [
                        {
                            type: 'blockMD'
                        }
                    ]
                },
                [
                    {
                        content: ['blockSM', 'blockSM', 'blockSM', 'blockSM', 'blockSM', 'blockSM']
                    }
                ]
            )
        },
        'empty',
        'line'
    ];
};

export const createVolumes = (marketData) => {
    const leftBranch = marketData?.structure_volumes?.find((volume) => +volume.position === 1);
    const rightBranch = marketData?.structure_volumes?.find((volume) => +volume.position === 2);

    return [
        {
            name: <T textName='personal_volume' defaultStr='Личный объем' />,
            icon: 'user-fill-colored',
            value: marketData?.total_personal_volume?.formatted_value || '0'
        },
        {
            name: <T textName='group_volume' defaultStr='Групповой объем' />,
            icon: 'users-fill-colored',
            value: marketData?.total_group_volume?.formatted_value || '0'
        },
        {
            name: <T textName='left_branch_volume' defaultStr='Объем левой ветки' />,
            icon: 'left-branch-fill-colored',
            value: leftBranch?.volume?.formatted_value || '0'
        },
        {
            name: <T textName='right_branch_volume' defaultStr='Объем правой ветки' />,
            icon: 'right-branch-fill-colored',
            value: rightBranch?.volume?.formatted_value || '0'
        }
    ];
};

export const progressPattern = () => {
    return [
        {
            row: [100],
            items: [
                {
                    content: [
                        {
                            type: 'circle',
                            diameter: 10,
                            align: 'center'
                        },
                        {
                            type: 'blockSM'
                        }
                    ]
                }
            ]
        }
    ];
};

export const getStrokeWidth = (width) => {
    switch (true) {
        case width < 480:
            return 20;
        case width < 992:
            return 10;
        default:
            return 20;
    }
};
